import React, { Fragment, useEffect, useState } from 'react';
import { Settings } from 'react-feather';
import { Link } from 'react-router-dom';
import { H6, Image, LI, UL, P } from '../../AbstractElements';
import man from '../../assets/images/dashboard/1.png';
import { useQuery } from 'react-query';
import { showEmployes } from '../../MyApi/sb/employes';

const Profile = () => {
    const authenticated = JSON.parse(localStorage.getItem('authenticated'));
    const auth0_profile = JSON.parse(localStorage.getItem('auth0_profile'));
    const [profile, setProfile] = useState('');
    const [name, setName] = useState(''); 
    const user = JSON.parse(localStorage.getItem("user")) ||{}
    const id =user.id 
    const {data ,isLoading}=useQuery(["showEmploye",id ],()=>showEmployes(id) )
    const employes = data?.data ||{}
    const {name_ar,name_en,image,role, active} = employes
    
    useEffect(() => {
        setProfile(localStorage.getItem('profileURL') || man);
        setName(localStorage.getItem('Name'));
    }, [setProfile, setName]);

    return (
        <Fragment>
            <div className="sidebar-user text-center">
                <Link to={"/user"} className="setting-primary" href="#javascript">
                    <Settings />
                </Link>
                 <Link to={`${process.env.PUBLIC_URL}/employ/${id}`}> 
                     <Image attrImage={{ className: 'img-90 rounded-circle ', src:  `${image}`, alt: '' }} /> 
                    <div className="badge-bottom">
                        <div className="badge badge-primary">
                        {`${
                active === 1 ? "Active" :  "Inactive"
          }`}
                        </div>
                    </div>
                    <H6 attrH6={{ className: 'mt-3 f-14 f-w-600' }} >{name_ar}</H6>
                </Link> 
                 <P attrPara={{ className: 'mb-0 font-roboto' }} >{role}</P>
                {/* <UL attrUL={{ className: 'flex-row simple-list' }}>
                    <LI><span><span className="counter">19.8</span>k</span>
                        <P>Follow</P>
                    </LI>
                    <LI><span>2 year</span>
                        <P>Experince</P>
                    </LI>
                    <LI><span><span className="counter">95.2</span>k</span>
                        <P>Follower </P>
                    </LI>
                </UL>  */}
            </div>
        </Fragment >
    );
};

export default Profile;